<template>
  <div class="room">
    <div @click="selectDate" style="color: black" class="room_header">
      <button class="btn">选择入住时间</button>
      <p>入住&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;离店</p>
      <p class="add_hoteltime"><span>{{this.startTime}} ~ {{this.endTime}}</span></p>
    </div>

    <calendar
      :minDate="minDate"
      :maxDate="maxDate"
      :show.sync="show"
      :defaultDate="defaultDate"
      mode="during"
      @change="onChange"/>

    <yd-preview v-for="(room,index) in roomList" :key="index" :buttons="[]">
      <yd-preview-header>
        <div slot="left">{{room.type}}</div>
        <div slot="right">{{room.price}}</div>
      </yd-preview-header>
      <yd-preview-item>
        <div slot="left">房型简介：</div>
        <div slot="right" class="room_remark">{{room.remark}}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left" style="line-height: .6rem;">
          数量： {{room.stock ? room.stock : 0}}
        </div>
        <div slot="right">
          <div v-if="room.stock === false || room.stock === null">
            <yd-button type="primary">预订已满</yd-button>
          </div>
          <div v-else-if="room.isend !== 1">
            <yd-button type="primary">预定已结束</yd-button>
          </div>
          <div v-else>
            <yd-button type="primary" @click.native="book(room.id,hotelname + '|' + room.type)">预订</yd-button>
          </div>
        </div>
      </yd-preview-item>
    <!--  <hr> -->
    </yd-preview>
    <img v-show="isCart" src="~assets/image/cart.png" id="cart" style="display: inline;" class="mescroll-totop2 mescroll-fade-in" @click="cart">
  </div>
</template>

<script type="text/babel">
import Vue from 'vue'
import Calendar from 'vue-mobile-calendar'
import axios from 'axios'

Vue.use(Calendar)

export default {
  data () {
    return {
      roomList: [],
      hotelname: '',
      startTime: '',
      endTime: '',
      day: '',
      params: this.$route.params,
      minDate: new Date(), // 设置过期时间为当天
      maxDate: '', // 设置过期时间为当天
      show: false,
      isCart: false,
      date: '',
      defaultDate: []
    }
  },
  methods: {
    selectDate () {
      this.show = true
      // this.date = ''
    },
    onChange (date) {
      let dateArr = date.map((item) => item.format('YYYY-MM-DD'))
      this.date = JSON.stringify(date.map((item) => item.format('YYYY-MM-DD')))
      this.startTime = dateArr[0]
      this.endTime = dateArr[1]
    },
    getHotel () {
      let dataf = {hotelid: this.params.hotelid, fairid: this.params.id}
      axios
        .post('/fair/fair-cont', dataf)
        .then((res) => {
          res = res.data
          if (res.status) {
            this.startTime = res.hoteldata.min
            this.endTime = res.hoteldata.max
            this.minDate = res.hoteldata.min
            this.maxDate = res.hoteldata.max
            this.defaultDate = [res.hoteldata.min, res.hoteldata.max]
            this.getHotelRoom()
          }
        })
    },
    getHotelRoom () {
      let data = {hotelid: this.params.hotelid, intime: this.startTime, outtime: this.endTime}
      axios
        .post('/hotel/hotel-room', data)
        .then(this.getHotelRoomSucc)
    },
    getHotelRoomSucc (res) {
      res = res.data
      if (res.status) {
        this.roomList = res.data.room
        this.hotelname = res.data.hotelname
      }
    },
    book (roomid, n) {
      this.$dialog.confirm({
        title: '请确认入住时间',
        mes: '入住时间：' + this.startTime + '，离开时间：' + this.endTime,
        opts: () => {
          let data = {
            uid: this.$store.state.uid,
            num: 1,
            ruzhu: this.startTime,
            tuifang: this.endTime,
            day: this.day,
            roomid: roomid,
            hotelid: this.params.hotelid,
            goods_name: n,
            fair_id: this.params.id
          }
          let that = this
          axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
          axios
            .post('/hotel/book-hotel', data)
            .then((res) => {
              res = res.data
              if (res.status === 1) {
                this.$router.push({path: '/' + this.params.id + '/room-buy'})
              } else {
                this.$dialog.toast({
                  mes: res.msg
                })
              }
            })
            .catch(function (res) {
              localStorage.clear()
              that.$dialog.toast({mes: '身份过期请重新登录'})
              window.location.reload()
            })
        }
      })
    },
    dateMinus (date1, date2) { // date1:小日期   date2:大日期
      var sdate = new Date(date1)
      var now = new Date(date2)
      var days = now.getTime() - sdate.getTime()
      var day = parseInt(days / (1000 * 60 * 60 * 24))
      return day
    },
    cart () {
      this.$router.push({path: '/' + this.params.id + '/room-buy'})
    },
    HistoryBack () {
      window.history.back()
    },
    getCart () {
      let that = this
      let dataf = {uid: this.$store.state.uid, fair_id: this.params.id}
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
      axios
        .post('/hotel/request-book', dataf)
        .then((res) => {
          res = res.data
          if (res.status) {
            this.isCart = true
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    checkLogin () {
      if (!this.$store.state.uid) {
        this.$router.push({path: '/' + this.params.id + '/single-my'})
      }
    }
  },
  mounted () {
    this.checkLogin()
    this.getHotel()
    this.getCart()
  },
  watch: {
    endTime: function () {
      this.day = this.dateMinus(this.startTime, this.endTime)
      this.getHotelRoom()
    }
  }
}
</script>

<style lang="stylus" scoped>
  .mescroll-totop2
    z-index: 9990
    position: fixed
    right: 10px
    bottom: 250px
    width: 36px
    height: 36px
    border-radius: 50%


  .yd-preview
    width: calc(100% - .4rem)
    margin: 0 auto
    border-radius: .2rem
    margin-bottom: .2rem


  .yd-preview-header
    margin-left: .4rem
    padding-right: .4rem
    height: .8rem


  .yd-preview-item
    padding: 0 .4rem .2rem .4rem

  .room_header
    width:calc(100% - .4rem)
    background-color: #fff
    margin: 0 auto
    border-radius: .2rem
    padding: .2rem .4rem
    margin: .2rem auto

  .room_header p
    color: #333
    margin-top: .2rem

  .room
    padding: .2rem 0
    height: 100%

  .btn
    font-weight: bold
    color: #333

  .btn::before
    content:""
    width: .08rem
    height: .28rem
    background-color: #00C800
    position: absolute
    margin-top: .02rem
    left: .4rem

  .room_remark
    max-width: 90%
    overflow:  hidden
    text-align: left
    text-overflow: ellipsis
    display:-webkit-box
    -webkit-box-orient:vertical
    -webkit-line-clamp: 1
    line-height: 1.5

  .yd-preview-header::after
    width: calc(100% - 0.4rem)

  .add_hoteltime span
    padding 0.1rem 0.25rem
    border 1px solid #dcdcdc
  
</style>



// WEBPACK FOOTER //
// src/views/template1/HotelRoom.vue